import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";

class DeleteWishlistItemSdkMethodPayload implements SdkMethodPayloadInterface {
    public readonly methodName: WISHLISTS_SDK_METHODS.DELETE_WISHLIST_ITEM;
    public readonly productId: number;
    public readonly variantId?: number;
    public readonly wishlistId?: number;
    public onSuccess: () => void;
    public onError: (error: Error) => void;

    constructor(
        productId: number,
        onSuccess: () => void,
        onError: (error: Error) => void,
        variantId?: number,
        wishlistId?: number
    ) {
        this.methodName = WISHLISTS_SDK_METHODS.DELETE_WISHLIST_ITEM;
        this.productId = productId;
        this.variantId = variantId;
        this.wishlistId = wishlistId;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default DeleteWishlistItemSdkMethodPayload;
